import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { NavbarThemeProvider } from "./contexts/NavbarThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Navigation/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import Technologies from "./pages/Technologies";
import Cases from "./pages/Cases";
import Blog from "./pages/Blog";
import Price from "./pages/Price";
import NotFound from "./pages/NotFound";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop";
import PageMeta from "./components/PageMeta";
import MetrikaTracker from "./components/MetrikaTracker";
import APM from "./pages/APM";
import Education from "./pages/Education";
import Techs from "./pages/SupportedTechnologies";
import Partners from "./pages/Partners";
import Registration from "./pages/Registration";
import Agreement from "./pages/Agreement";
import Login from "./pages/Login";
import Client from "./pages/Client";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import EmailConfirmation from "./pages/EmailConfirmation";
import UsefulMaterials from "./pages/Clients/UsefuleMaterials";
import Videos from "./pages/Videos";
import SeasonsGreetings from "./pages/SeasonsGreetings";
import MCP from "./pages/MCP";
import Mib from "./pages/Mib";

const App = () => {
  return (
    <AuthProvider>
      <NavbarThemeProvider>
        <Router>
          <div className="min-h-screen bg-gray-100">
            <PageMeta />
            <ScrollToTop />
            <MetrikaTracker />
            <Navbar />
            <main className="min-h-[calc(100vh-900px)]">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/technologies" element={<Technologies />} />
                <Route path="/cases" element={<Cases />} />
                <Route path="/partners" element={<Partners />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:id" element={<Blog />} />
                <Route path="/cenoobrazovanie" element={<Price />} />
                <Route path="/about-apm" element={<Price />} />
                <Route path="/apm" element={<APM />} />
                <Route path="/apm/:id" element={<APM />} />
                <Route path="/education" element={<Education />} />
                <Route path="/supported-technologies" element={<Techs />} />
                <Route path="/supported-technologies/:id" element={<Techs />} />
                <Route path="/registration" element={<Registration />} />
                <Route path="/agreement" element={<Agreement />} />
                <Route path="/NY2026" element={<SeasonsGreetings />} />
                <Route path="/privacy" element={<Agreement />} />
                <Route path="/terms" element={<Agreement />} />
                <Route path="/login" element={<Login />} />
                <Route path="/forgot_password" element={<ForgotPassword />} />
                <Route path="/reset_password" element={<ResetPassword />} />
                <Route path="/confirm_email" element={<EmailConfirmation />} />
                <Route path="/confirm-email" element={<EmailConfirmation />} />
                <Route path="/mcp" element={<MCP />} />
                <Route path="/mib" element={<Mib />} />
                <Route element={<ProtectedRoute />}>
                  <Route path="/client/*" element={<Client />} />
                  <Route
                    path="/client/useful-materials"
                    element={<UsefulMaterials />}
                  />
                  <Route path="/client/videos" element={<Videos />} />
                  <Route path="/client/videos/:id" element={<Videos />} />
                </Route>

                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </NavbarThemeProvider>
    </AuthProvider>
  );
};

export default App;
